module.exports = __webpack_public_path__ + "poppins-regular_0-webfont.2c74a858358af63b2e27.woff2";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/fonts/poppins-regular_0-webfont.woff2
// module id = ../../../../../src/assets/fonts/poppins-regular_0-webfont.woff2
// module chunks = 2